import { render } from "./HibobEntityInput.vue?vue&type=template&id=21bc3224"
import script from "./HibobEntityInput.vue?vue&type=script&lang=js"
export * from "./HibobEntityInput.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__